export default "__VITE_ASSET__CDv$Kcm5__"